<template>
  <v-dialog
    v-model="localValue"
    dark
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-app-bar
        dark
        fixed
        class="v-app-bar--normal"
      >
        <v-spacer />
        <v-select
          v-model="displayFile"
          :items="fileCtxs"
          :item-text="item => showItemText(item)"
          return-object
          hide-details
          style="max-width: 88%;"
        />
        <v-btn
          v-if="displayFile && $config.isBrowser"
          icon
          dark
          @click="downloadFile"
        >
          <v-icon>
            {{ mdiDownload }}
          </v-icon>
        </v-btn>
        <v-spacer />
        <v-btn
          icon
          dark
          @click="close"
        >
          <v-icon>{{ mdiClose }}</v-icon>
        </v-btn>
      </v-app-bar>
      <v-container
        class="pa-0"
        style="margin-top: 56px;"
      >
        <div
          v-if="loading"
          class="text-center mt-2"
          style="padding: 10px"
        >
          <v-progress-circular
            size="50"
            color="primary"
            indeterminate
          />
        </div>
        <div v-if="!loading">
          <div v-if="isPdf || isEncryptedPdf">
            <pdf
              v-for="i in numPages"

              :key="i"
              :page="i"
              :src="src"
              style="width:100%; margin: 10px;"
              :scale="'page-width'"
            />
          </div>
          <div v-else-if="isPicture || isEncryptedPicture">
            <v-img
              class="mx-auto"
              max-width="1000"
              :src="src"
            />
          </div>
          <div
            v-else
            class="pa-4"
          >
            <v-sheet
              class="text-center black--text mx-auto pa-4"
              color="grey lighten-3"
              width="300"
            >
              {{ $t('PdfViewer.CannotPreview') }}
              <br>
              <v-btn
                v-if="$config.isBrowser"
                color="primary"
                :loading="downloading"
                @click="downloadFile"
              >
                {{ $t('PdfViewer.Download') }}
              </v-btn>
            </v-sheet>
          </div>
        </div>
      </v-container>
      <s-encrypt-password-dialog
        v-if="isEncryptedFile"
        ref="passwordDialog"
        @hook:mounted="isEncryptPasswordDialogMounted = true"
      />
    </v-card>
  </v-dialog>
</template>

<script>

import pdf from 'vue-pdf'
import Axios from 'axios'
// import { isIos } from '@/utils/utils'
import { commonComponentModule } from '@/store/moduleName'
import SEncryptPasswordDialog from '@/components/SEncryptPasswordDialog.vue'
import CryptoUtilFile from '@/lib/g2e/CryptoUtilFile.js'
import { mdiDownload, mdiClose } from '@mdi/js'
import { mapGetters, mapMutations } from 'vuex'

let passwordDialogResolveFn

/**
 * @param {String} fileType - For example 'jpg' or 'jpeg'
 * @returns {Boolean} Returns the file format
 */
function _isPictureFileType (fileType) {
  if (!fileType) return false
  switch (fileType) {
    case 'jpg':
      return true
    case 'jpeg':
      return true
    case 'png':
      return true
    default:
      return false
  }
}

export default {
  components: {
    pdf,
    SEncryptPasswordDialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    fileCtxs: {
      type: Array,
      default: null
    }
    // encryptedFileKey: {
    //   type: String,
    //   default: null
    // }
  },
  data () {
    return {
      src: null,
      numPages: undefined,
      loading: false,
      displayFile: null,
      downloading: false,
      isEncryptPasswordDialogMounted: false,
      mdiDownload: mdiDownload,
      mdiClose: mdiClose
    }
  },
  computed: {
    ...mapGetters(commonComponentModule, ['decryptedFileKey']),
    // ...mapState({
    //   encryptedFileKey: state => state[commonComponentModule].encrypted.fileKey
    // }),
    localValue: {
      get: function () {
        return this.value
      },
      set: function (val) {
        this.$emit('input', val)
      }
    },
    isPdf () {
      return (this.displayFile && (this.displayFile.fileExtension.toLowerCase() === 'pdf'))
    },
    isPicture () {
      return (this.displayFile && _isPictureFileType(this.displayFile.fileExtension.toLowerCase()))
    },
    isEncryptedFile () {
      return (this.displayFile && (this.displayFile.fileExtension.toLowerCase() === 'encrypted'))
    },
    isEncryptedPdf () {
      return (this.isEncryptedFile && this.displayFile.displayName.trim().toLowerCase().endsWith('.pdf'))
    },
    isEncryptedPicture () {
      if (this.isEncryptedFile) {
        let splitedFileName = this.displayFile.displayName.trim().toLowerCase().split('.')
        return _isPictureFileType(splitedFileName[splitedFileName.length - 1])
      }
      return false
      // return this.displayFile && this.displayFile.fileExtension.toLowerCase() === 'encrypted' && this.displayFile.displayName.trim().toLowerCase().endsWith('.pdf')
    }
  },
  watch: {
    localValue: function (val) {
      if (val && this.fileCtxs && this.fileCtxs.length > 0) {
        this.displayFile = this.fileCtxs[0]
      }
    },
    displayFile: async function (val) {
      if (this.isPdf) {
        this.getPdf(val)
      } else if (this.isEncryptedPdf) {
        if (!this.isEncryptPasswordDialogMounted) {
          await this.waitPasswordDialogReady()
        }
        this.getEncryptedPdf(val)
      } else if (this.isPicture) {
        this.getImage()
      } else if (this.isEncryptedPicture) {
        if (!this.isEncryptPasswordDialogMounted) {
          await this.waitPasswordDialogReady()
        }
        this.getEncryptedImage()
      }
    },
    isEncryptPasswordDialogMounted: function (val) {
      if (val && passwordDialogResolveFn) {
        passwordDialogResolveFn(true)
      }
    },
    isEncryptedFile: function (val) {
      if (!val) {
        this.isEncryptPasswordDialogMounted = false
      }
    }
  },
  methods: {
    ...mapMutations(commonComponentModule, ['setDecryptedFileKey']),
    getPdf (displayFile) {
      this.loading = true
      this.numPages = 0
      this.src = pdf.createLoadingTask(displayFile.url)
      this.src.then(pdf => {
        this.src._worker.destroy()
        this.numPages = pdf.numPages
        this.loading = false
      })
    },
    async getEncryptedPdf (displayFile) {
      this.loading = true
      this.numPages = 0

      let isSuccessGetPassword = await this.getPasswordByDialog()
      if (!isSuccessGetPassword) {
        this.loading = false
        return
      }

      let url = await this.getFileFromServer()
      this.src = pdf.createLoadingTask(url)
      this.src.then(pdf => {
        this.src._worker.destroy()
        this.numPages = pdf.numPages
        this.loading = false
      })
      // this.src = pdf.createLoadingTask(displayFile.url)
      // this.src.then(pdf => {
      //   this.src._worker.destroy()
      //   this.numPages = pdf.numPages
      //   this.loading = false
      // })
    },
    getImage () {
      if (this.displayFile) {
        this.loading = true
        Axios.get(this.displayFile.url.url, {
          responseType: 'blob'
        }).then(
          resp => {
            this.loading = false
            if (resp.status === 201 || resp.status === 200) {
              this.src = window.URL.createObjectURL(new Blob([resp.data]))
            }
            // else {
            //   this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.DownloadFailed'))
            // }
          },
          error => {
            this.loading = false
            console.log(error)
            // this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.DownloadFailed'))
          }
        )
      }
    },
    async getEncryptedImage () {
      let isSuccessGetPassword = await this.getPasswordByDialog()
      if (!isSuccessGetPassword) {
        this.loading = false
        return
      }
      let url = await this.getFileFromServer()
      this.src = url
    },
    close () {
      this.localValue = false
      this.src = null
      this.numPages = undefined
      this.loading = false
      this.displayFile = null
    },
    async downloadFile () {
      if (this.displayFile) {
        if (this.isEncryptedFile) {
          let isSuccessGetPassword = await this.getPasswordByDialog()
          if (!isSuccessGetPassword) return
        }
        let url = await this.getFileFromServer()

        // out = new Blob([resp.data])

        let fileName
        if (this.isEncryptedFile) {
          fileName = this.displayFile.displayName
        } else {
          fileName = this.displayFile.displayName + '.' + this.displayFile.fileExtension
        }

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        link.click()
        window.URL.revokeObjectURL(url)

        // if (isIos()) {
        //   // out = new Blob([resp.data], { type: 'application/pdf' })
        //   // fileName = this.displayFile.displayName + '.' + this.displayFile.fileExtension
        //   let reader = new FileReader()
        //   let documentLink = document.createElement('a')
        //   documentLink.style = 'display: none'
        //   reader.onload = (e) => {
        //     // window.location.href = reader.result
        //     documentLink.href = reader.result
        //     documentLink.download = fileName
        //     document.body.appendChild(documentLink)
        //     documentLink.click()
        //   }
        //   reader.readAsDataURL(out)
        // }
      }
    },
    showItemText (item) {
      if (item.docTypeI18nCode) {
        return item.displayName + '.' + item.fileExtension + '  (' + this.$t(item.docTypeI18nCode) + ')'
      }
      return item.displayName + '.' + item.fileExtension
    },

    /**
    * This function get user password and decrypted file key, the key is saved in the vuex commonComponentModule
    * by the SEncryptPasswordDialog component
    * @returns {boolean} // if success get password return true, if fail return false
    */
    async getPasswordByDialog () {
      if (!this.decryptedFileKey) {
        await this.$refs.passwordDialog.getPassword().catch(() => {})
        if (this.decryptedFileKey) {
          return true
        }
        return false
      } else {
        return true
      }
    },
    /**
    * Get file from server, if it is encrypted file, it will decrypt it
    * @returns {window.URL} it can be used to display on pdf.js or download link
    */
    async getFileFromServer () {
      this.downloading = true
      return new Promise(resolve => {
        Axios.get(this.displayFile.url.url, {
          responseType: 'blob'
        }).then(
          async resp => {
            this.downloading = false
            if (resp.status === 201 || resp.status === 200) {
              let out = resp.data
              if (this.isEncryptedFile) {
                out = await CryptoUtilFile.decryptFile(resp.data, this.decryptedFileKey, 'application/pdf').catch((error) => {
                  console.error(error) // password錯, 不應該發生, 應該在decrypt user privateKey時已知道錯, 測試時會用到此catch
                  // this.decryptedFileKey = null
                  this.setDecryptedFileKey(null)
                  if (this.fileCtxs && this.fileCtxs.length > 0) { // force user input password and decrypte the file key.
                    this.displayFile = null
                    this.displayFile = this.fileCtxs[0]
                  }
                  return false
                })
              }
              if (out) {
                resolve(window.URL.createObjectURL(out))
              }

            // let fileName = this.displayFile.displayName
            }
            // else {
            //   this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.DownloadFailed'))
            // }
          },
          error => {
            this.downloading = false
            console.log(error)
            // this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.DownloadFailed'))
          }
        )
      })
    },
    waitPasswordDialogReady () { // wait someone set isEncryptPasswordDialogMounted to true (watch isEncryptPasswordDialogMounted)
      return new Promise((resolve) => {
        passwordDialogResolveFn = resolve
      })
    }
  }
}
</script>
